<h1 mat-dialog-title>Success</h1>
<div mat-dialog-content>
  {{data.name}}
</div>
<div mat-dialog-actions>
  <button mat-button mat-raised-button color="primary" [mat-dialog-close]="data.name" cdkFocusInitial>Ok</button>
</div>
